import type { CartV1Attributes } from '@/features/cart/cart-v1/cart-v1-type';

import React from 'react';

import { IconImage, ModalWithText } from '@/core/features';
import { useMetaDataState } from '@/core/features/a-dynamic-page/hooks/meta-data-state';
import CartCtaWrapperDesktop from '@/features/cart/cart-v1/cart-cta-wrapper-desktop';

export default function CartV1Desktop({ errorOverlay, tracking }: CartV1Attributes) {
    const [isErrorOverlayOpen, setErrorOverlayOpen] = React.useState(!!errorOverlay);
    const metaData = useMetaDataState();

    if (!metaData?.cartMeta) {
        return null;
    }

    return (
        <>
            <CartCtaWrapperDesktop
                activitySpotId={metaData?.cartMeta.activitySpotId}
                isDisabled={metaData?.cartMeta.isDisabled}
                isOverlayInitiallyOpen={isErrorOverlayOpen}
                schoolId={metaData?.cartMeta.schoolId}
                tracking={tracking}
            />
            {errorOverlay && isErrorOverlayOpen && (
                <ModalWithText
                    gap={'gap-16'}
                    headerSlot={
                        <IconImage
                            height={50}
                            url={errorOverlay.iconUrl}
                            width={50}
                        />
                    }
                    htmlText={errorOverlay.htmlText}
                    htmlTitle={errorOverlay.headline}
                    onClose={() => setErrorOverlayOpen(false)}
                    padding={'padding-20'}
                    textAlignment={'text-center'}
                    titleFontSize={'font-size-18'}
                    titleStyle={{ color: errorOverlay.headlineColor }}
                />
            )}
        </>
    );
}
